import React, { useEffect, useState } from "react";
import MetaData from "../layout/MetaData";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { calculateOrderCost } from "../../helpers/Helpers";
import CheckoutSteps from "./CheckoutSteps";
import { useCreateNewOrderMutation } from "../../redux/api/orderApi";
import { toast } from "react-hot-toast";
import { clearCart } from "../../redux/features/cartSlice";

const ConfirmOrder = () => {
    const { cartItems, shippingInfo } = useSelector((state) => state.cart);
    const { user } = useSelector((state) => state.auth);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [method, setMethod] = useState("");
    const [jazzcashScreenshot, setJazzcashScreenshot] = useState("");
    const [jazzcashFileName, setJazzcashFileName] = useState("");

    const [createNewOrder, { isLoading, error, isSuccess }] = useCreateNewOrderMutation();

    const { itemsPrice, shippingPrice, taxPrice } = calculateOrderCost(cartItems);

    const cityLower = String(shippingInfo?.city || '').trim().toLowerCase();
    const inKarachi = cityLower === 'karachi';
    const methodShipping = method === "COD"
        ? (inKarachi ? 190 : 380)
        : method === "JazzCash"
            ? (inKarachi ? 290 : 480)
            : 0;
    const displayTotal = (Number(itemsPrice) + Number(methodShipping)).toFixed(2);

    // useEffect(() => {
    //     if (error) toast.error(error?.data?.message);
    //     if (isSuccess) navigate("/me/orders?order_success=true");
    // }, [error, isSuccess, navigate]);

    const { isAuthenticated } = useSelector((state) => state.auth);

    useEffect(() => {
        if (error) toast.error(error?.data?.message);
        if (isSuccess) {
            // Show one success toast regardless of device
            toast.success("Your order has been placed successfully!");
            if (!isAuthenticated) {
                // Guest checkout: clear cart before redirect
                dispatch(clearCart());
                navigate("/?order_success=true");
            } else {
                navigate("/me/orders?order_success=true");
            }
        }
    }, [error, isSuccess, isAuthenticated, navigate, dispatch]);

    const placeOrderHandler = (e) => {
        e.preventDefault();
        if (!method) return toast.error("Please select a payment method");
        if (method === "JazzCash" && !jazzcashScreenshot) {
            return toast.error("Please upload JazzCash transaction screenshot");
        }

        const orderData = {
            shippingInfo,
            orderItems: cartItems,
            itemsPrice,
            shippingAmount: methodShipping,
            taxAmount: taxPrice,
            totalAmount: displayTotal,
            paymentInfo: {
                status: "not_paid",
                ...(method === "JazzCash" ? { screenshot: jazzcashScreenshot } : {}),
            },
            paymentMethod: method === "JazzCash" ? "JazzCash" : "COD",
        };

        if (!isAuthenticated) {
            orderData.guestInfo = {
                name: shippingInfo.name,
                email: shippingInfo.email,
            };
        }

        createNewOrder(orderData);
    };

    return (
        <>
            <MetaData title="Confirm & Pay" />
            <CheckoutSteps shipping confirmOrder payment />

            <main className="main-content">
                <div className="container d-flex justify-content-center">
                    <div
                        className="cart-card shadow-sm rounded-4 p-4 w-100"
                        style={{ maxWidth: "1100px" }}
                    >

                        {/* Page Heading */}
                        <h1 className="heading text-center mb-5">Confirm Your Order</h1>

                        <div className="row">
                            {/* Shipping & Cart Info */}
                            <div className="col-12 col-lg-8">
                                <div className="product-card shadow-sm rounded-4 p-4 mb-4 shipping-cart-card">
                                    <h4 className="mb-3 fw-semibold" style={{ color: "#e04f6ecd" }}>Shipping Info</h4>
                                    <p style={{ color: "#e04f6ecd" }}>
                                        <b style={{ color: "#e04f6ecd" }}>Name:</b > {shippingInfo?.name || user?.name || "Guest"}
                                    </p>

                                    <p style={{ color: "#e04f6ecd" }}>
                                        <b style={{ color: "#e04f6ecd" }}>Phone:</b> {shippingInfo?.phoneNo}
                                    </p>
                                    <p className="mb-4" style={{ color: "#e04f6ecd" }}>
                                        <b style={{ color: "#e04f6ecd" }}>Address:</b> {shippingInfo?.address},{" "}
                                        {shippingInfo?.city}, {shippingInfo?.zipCode},{" "}
                                        {shippingInfo?.country}
                                    </p>

                                    <hr />
                                    <h4 className=" fw-semibold mt-4" style={{ color: "#e04f6ecd" }}>Your Cart Items</h4>

                                    {cartItems?.length > 0 ? (
                                        cartItems.map((item) => (
                                            <div
                                                key={item.product}
                                                className="cart-item d-flex align-items-center justify-content-between py-3 border-bottom"
                                            >
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={item?.image}
                                                        alt={item?.name}
                                                        className="rounded me-3 cart-thumb"
                                                    />
                                                    <Link
                                                        to={`/product/${item.product}`}
                                                        className="fw-semibold text text-decoration-none" style={{ color: "#e04f6ecd" }}
                                                    >
                                                        {item?.name}
                                                    </Link>
                                                </div>
                                                <div className="cart-line-price">
                                                    {item?.variant?.name ? (
                                                        <p className="mb-1 small text" style={{ color: "#e91e63" }}>
                                                            Variant: <span className="fw-semibold">{item.variant.name}</span>
                                                        </p>
                                                    ) : null}
                                                    {Array.isArray(item?.colors) && item.colors.length > 0 ? (
                                                        <p className="mb-1 small text" style={{ color: "#e91e63" }}>
                                                            Selected: {item.colors.join(", ")}
                                                        </p>
                                                    ) : item?.color ? (
                                                        <p className="mb-1 small text" style={{ color: "#e91e63" }}>Selected: <span className="fw-semibold">{item.color}</span></p>
                                                    ) : null}
                                                    <p className="mb-0 fw-medium" style={{ color: "#e04f6ecd" }}>
                                                        {item?.quantity} x  {item?.price} ={" "}
                                                        <b style={{ color: "#e91e63" }}>
                                                            PKR {(item?.quantity * item?.price).toFixed(2)}
                                                        </b>
                                                    </p>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-muted mt-3">No items in cart.</p>
                                    )}
                                </div>
                            </div>

                            {/* Fixed Order Summary + Payment */}
                            <div className="col-12 col-lg-4">
                                <div className="cart-card shadow-sm rounded-4 p-4 order-summary-card">
                                    <h4 className="fw-bold" style={{ color: "#e04f6ecd" }}>Order Summary</h4>
                                    <hr />
                                    <p style={{ color: "#e04f6ecd" }}>
                                        Subtotal:{" "}
                                        <span className="fw-semibold text" style={{ color: "#e91e63" }}>
                                            PKR {itemsPrice}
                                        </span>
                                    </p>

                                    <div className="mb-3">
                                        <label className="form-label fw-semibold" style={{ color: "#e04f6ecd" }}>Select Payment Method</label>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="pay_method" id="cod_opt" value="COD" onChange={() => setMethod("COD")} />
                                            <label className="form-check-label" style={{ color: "#e04f6ecd" }} htmlFor="cod_opt">Cash on Delivery (Shipping PKR {inKarachi ? 190 : 380})</label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="pay_method" id="jazz_opt" value="JazzCash" onChange={() => setMethod("JazzCash")} />
                                            <label className="form-check-label" style={{ color: "#e04f6ecd" }} htmlFor="jazz_opt">JazzCash (Shipping PKR {inKarachi ? 290 : 480})</label>
                                        </div>
                                    </div>

                                    {method && (
                                        <p style={{ color: "#e04f6ecd" }}>
                                            Shipping:{" "}
                                            <span className="fw-semibold" style={{ color: "#e91e63" }}>PKR {methodShipping}</span>
                                        </p>
                                    )}

                                    {method === "JazzCash" && (
                                        <div className="jazzcash-panel rounded-4 p-3 shadow-sm">
                                            <h6 className="fw-bold mb-2">Jazzcash Payment Details</h6>
                                            <ul className="mb-2">
                                                <li><b>Account Name:</b> Maham Rizwan</li>
                                                <li><b>Jazzcash Number:</b> 0321-2413134</li>
                                            </ul>
                                            <div className="mb-2">
                                                <label className="form-label fw-semibold">Upload Transaction Screenshot*</label>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0];
                                                        if (!file) return;
                                                        setJazzcashFileName(file.name);
                                                        const reader = new FileReader();
                                                        reader.onloadend = () => setJazzcashScreenshot(String(reader.result));
                                                        reader.readAsDataURL(file);
                                                    }}
                                                />
                                                {jazzcashFileName && (
                                                    <small className="text-muted">Selected: {jazzcashFileName}</small>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    <hr />
                                    <h5 style={{ color: "#e04f6ecd" }}>
                                        Total:{" "}
                                        <span className="text fw-bold" style={{ color: "#e91e63" }}>
                                            PKR {method ? displayTotal : (Number(itemsPrice) + Number(shippingPrice)).toFixed(2)}
                                        </span>
                                    </h5>
                                    <hr />
                                    <button
                                        id="place_order_btn"
                                        className="btn View-btn w-100 fw-semibold"
                                        disabled={isLoading}
                                        onClick={placeOrderHandler}
                                    >
                                        {isLoading ? "Placing..." : "Place Order"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default ConfirmOrder;